import React from 'react';
import { NetworkConfig } from '../config/networks';
import './PolicyDescription.css';

interface PolicyDescriptionProps {
  currentNetwork?: NetworkConfig;
  contractAddress?: string;
  isConnected?: boolean;
}

const PolicyDescription: React.FC<PolicyDescriptionProps> = ({ currentNetwork, contractAddress, isConnected }) => {
  // Default email domain from backend policy
  const whitelistedEmailDomain = "trustline.id";
  
  return (
    <div className="policy-section">
      <div className="policy-header">
        <h3>Policy</h3>
        {currentNetwork && contractAddress && (
          <a 
            href={`${currentNetwork.blockExplorer}/address/${contractAddress}`}
            target="_blank"
            rel="noopener noreferrer"
            className="explorer-link"
          >
            View contract on explorer ↗
          </a>
        )}
      </div>
      <div className="policy-content">
        <p className="policy-description">
          Transactions made on{' '}
          {currentNetwork && contractAddress ? (
            <a 
              href={`${currentNetwork.blockExplorer}/address/${contractAddress}`}
              target="_blank"
              rel="noopener noreferrer"
              className="escrow-link"
            >
              this escrow
            </a>
          ) : (
            'this escrow'
          )}
          {' '}are subject to verifications through Trustline trusted providers.
        </p>
        {isConnected && (
          <div className="policy-items">
            <div className="policy-item">
              <div className="policy-item-header">
                <span className="policy-name">Watch Lists</span>
                <div className="policy-scopes">
                  <span className="policy-scope scope-sender">Sender</span>
                  <span className="policy-scope">Beneficiary</span>
                </div>
              </div>
              <ul className="policy-desc policy-list">
                <li>OFAC Sanctions list</li>
                <li>Community self-reported lists</li>
                <li>Service internal lists</li>
              </ul>
            </div>
            <div className="policy-item">
              <div className="policy-item-header">
                <span className="policy-name">End-User Verification</span>
                <span className="policy-scope">Beneficiary</span>
              </div>
              <span className="policy-desc">
              <ul className="policy-desc policy-list">
                <li>For all transfers, <strong>Email</strong> verification of the beneficiary, which needs to belong to: <strong>@{whitelistedEmailDomain}</strong></li>
                <li>For high amount transfers, <strong>Phone number</strong> verification of beneficary within: <strong>EU or US region</strong>.</li>
              </ul>
              </span>
            </div>
            <div className="policy-item">
              <div className="policy-item-header">
                <span className="policy-name">Fraud & Hack Prevention</span>
                <div className="policy-scopes">
                  <span className="policy-scope">Beneficiary</span>
                  <span className="policy-scope scope-transaction">Transaction</span>
                </div>
              </div>
              <ul className="policy-desc policy-list">
                <li><strong>Simulate tx impact</strong> on smart contract.</li>
                <li>Check <strong>risk score</strong> for tx wallets and assets.</li>
                <li>Require secondary beneficiary verification for <strong>high amount transfers.</strong></li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PolicyDescription;
